import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class StoriesService {
  constructor(private http: HttpClient) {}

  getStories(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/content/admin/getStories`, {
      headers: { lang: langCode },
      params: { searchTerm },
    });
  }

  createStory(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/content`, data);
  }

  getStoriesById(id: any, langCode?: any): Observable<any> {
    return this.http.get(
      `${environment.authUrl}/content/admin/getStory/${id}`,
      {
        headers: { lang: langCode },
      }
    );
  }

  removeStory(id: any): Observable<any> {
    return this.http.delete(`${environment.authUrl}/content/${id}`);
  }

  updateStory(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/content/${id}`, data);
  }

  translateContent(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/content/translation`, data);
  }

  createVideoStory(data: any): Observable<any> {
    return this.http.post(`${environment.authUrl}/content/video`, data);
  }

  updateVideoStory(id: any, data: any): Observable<any> {
    return this.http.patch(`${environment.authUrl}/content/updateVideo/${id}`, data);
  }

  getVideoStories(langCode: any, searchTerm: string = ''): Observable<any> {
    return this.http.get(`${environment.authUrl}/content/admin/getVideos`, {
      headers: { lang: langCode },
      params: { searchTerm },
    });
  }

  getVideoStoriesById(id: any, langCode?: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/content/video/${id}`, {
      headers: { lang: langCode },
    });
  }

  deleteVideoStory(id: any): Observable<any> {
    return this.http.delete(
      `${environment.authUrl}/content/deletetranslation/${id}`
    );
  }
}
